import MetricPage from './metric.page';

export default MetricPage;
